import React, { Component } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import FrontNav from '../../../components/FrontNav';
import TabNav from '../../../components/TabNav';
import ProjectList from '../../../components/Activity/Project/ProjectList';

class ScreenProjectsList extends Component {
	render () {
		return (
			<section>
				<Header />
				<FrontNav match={this.props.match} />
				<TabNav match={this.props.match} />
			    <ProjectList />
			    <Footer />
			</section>
		)
	}
}

export default ScreenProjectsList;